import { render } from "./resume-header.vue?vue&type=template&id=fc4e1884&scoped=true"
import script from "./resume-header.vue?vue&type=script&lang=js"
export * from "./resume-header.vue?vue&type=script&lang=js"

import "./resume-header.vue?vue&type=style&index=0&id=fc4e1884&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4e1884"]])

export default __exports__